const resource = {
    resource_identifier_in_use: '"El identificador de API {{indicator}} ya está en uso',
    /** UNTRANSLATED */
    cannot_delete_management_api: 'Cannot delete Logto management API.',
};
export default Object.freeze(resource);
